/**
 * Что и когда слать в живой эфир (MADR 0040). Чистая логика без сети и стора: вход — текущая волна боя
 * (`GameController.live()`) и состояние интерфейса, выход — чанк в `send`.
 *
 * Шлём сразу, когда изменилось число команд, волна или экран; в бою — не реже раза в `intervalMs`, чтобы зритель видел
 * текущий тик; между волнами и в свёрнутом окне молчим, пока ничего не меняется. Чанк несёт волну целиком, поэтому
 * потерянный или повторный запрос ничего не ломает.
 */
import type { LiveChunk, LiveUi } from "@newfungame/contracts";
import { MAX_LIVE_COMMANDS } from "@newfungame/contracts";
import type { LiveWave } from "../game/controller";

export interface LiveSenderDeps {
  send(chunk: LiveChunk): void;
  now(): number;
  intervalMs?: number;
}

export const LIVE_INTERVAL_MS = 5000;

export interface LiveSender {
  /** Проверить и при необходимости отправить. Зовётся на каждом тике и при смене экрана. */
  update(wave: LiveWave | null, ui: LiveUi): void;
}

const uiKey = (ui: LiveUi) => (ui.window ? `${ui.state}:${ui.window}` : ui.state);

export function createLiveSender(deps: LiveSenderDeps): LiveSender {
  const interval = deps.intervalMs ?? LIVE_INTERVAL_MS;
  let lastKey = "";
  let lastAt = -Infinity;
  return {
    update(wave, ui) {
      if (!wave || wave.commands.length > MAX_LIVE_COMMANDS) return;
      const key = `${wave.run.runId}|${wave.run.wave}|${wave.seed}|${wave.commands.length}|${uiKey(ui)}`;
      const now = deps.now();
      const due = ui.state === "battle" && now - lastAt >= interval;
      if (key === lastKey && !due) return;
      lastKey = key;
      lastAt = now;
      deps.send({
        runId: wave.run.runId,
        wave: wave.run.wave,
        seed: wave.seed,
        start: wave.run,
        ...(wave.vip ? { vip: true } : {}),
        commands: wave.commands,
        tick: wave.tick,
        ui,
      });
    },
  };
}
